const keys = {
  house: 'house',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  treat: 'treat',
}

const customClientConfig = {
  // override config from src/config/index.js in here
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Are you co-habiting?',
      answers: {
        A: 'I live on my own',
        B: 'I live with my partner'
      }
    },
    single: {
      [keys.house]: {
        question: 'What will your home in retirement be like?',
        answers: {
          A: 'The essentials are enough for me',
          B: 'Well furnished - I like a few home comforts',
          C: 'Show-home worthy, with all the mod cons',
        }
      },
      [keys.eatout]: {
        question: "You're eating out... where are you heading?",
        answers: {
          A: 'The chippy',
          B: 'The local pub',
          C: 'A nice restaurant',
        }
      },
      [keys.transport]: {
        question: 'How are you going to get around?',
        answers: {
          A: "I'll hop on the bus",
          B: "I'll drive a mid-range car",
          C: "Comfort is key for me - I'd like a luxury car",
        }
      },
      [keys.treat]: {
        question: "You're treating the family... what'll it be?",
        answers: {
          A: 'A trip to the cinema',
          B: 'A mini shopping spree',
          C: 'A full day out, with food and activities',
        }
      },
    }
  },
  inputs: {
    age: {
      currentValue: 30, // initial value
    },
    retirementAge: {
      currentValue: 67, // initial value
    },
  }
}

const state = {
  config: { ...customClientConfig }
}

export default {
  state
};
